module.exports = __webpack_public_path__ + "img/red_packet.9b716684.png";